import { render, staticRenderFns } from "./InputLogo.vue?vue&type=template&id=051beae3&scoped=true&lang=pug&"
import script from "./InputLogo.vue?vue&type=script&lang=ts&"
export * from "./InputLogo.vue?vue&type=script&lang=ts&"
import style0 from "./InputLogo.vue?vue&type=style&index=0&id=051beae3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051beae3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
